import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import { LanguageConsumer } from '../../state'

const Query = ({ render, member }) => (
  <LanguageConsumer>
    {({ lang }) => (
      <StaticQuery
        query={graphql`
          query {
            allContent: allFile(
              filter: { relativePath: { glob: "content/pages/team/*.md" } }
            ) {
              nodes {
                relativePath
                childMarkdownRemark {
                  frontmatter {
                    content {
                      title
                      search
                      search_submit
                      results
                      no_results
                      meta {
                        profile
                        team_member
                      }
                      teams {
                        label
                        key
                      }
                    }
                  }
                }
              }
            }

            blogPosts: allFile(
              filter: { relativePath: { glob: "content/blog-posts/*.md" } }
            ) {
              nodes {
                relativePath
                childMarkdownRemark {
                  frontmatter {
                    author
                    localized {
                      lang
                    }
                  }
                }
              }
            }

            teamMembers: allFile(
              filter: { relativePath: { glob: "content/profiles/*.md" } }
            ) {
              nodes {
                relativePath
                childMarkdownRemark {
                  frontmatter {
                    title
                    display_name
                    profile_image
                    thumbnail
                    fingerprint
                    team
                    is_active
                    is_team_member
                    order
                    localized {
                      lang
                      job_titles {
                        name
                        primary
                      }
                      location
                      profile_links {
                        youtube
                        email
                        linkedin
                        twitter
                        github
                      }
                      body_text
                    }
                  }
                }
              }
            }

            researchCreators: iohkResearchItems {
              researchItems {
                lang
                items {
                  creators {
                    key
                  }
                }
              }
            }
          }
        `}
        render={({ allContent, teamMembers, blogPosts, researchCreators }) => {
          const content = allContent.nodes
            .filter(
              (node) =>
                node.relativePath === `content/pages/team/team-${lang}.md`
            )
            .shift()

          if (!content || !content.childMarkdownRemark)
            throw new Error(`No team translations found for language ${lang}`)

          const blogAuthors = blogPosts.nodes
            .map((node) => {
              if (
                node.childMarkdownRemark.frontmatter.localized
                  .map(({ lang }) => lang)
                  .includes(lang)
              )
                return node.childMarkdownRemark.frontmatter.author

              return false
            })
            .filter((v) => !!v)

          const researchPaperAuthors = []
          const localizedResearchItems = (
            researchCreators.researchItems
              .filter(({ lang: language }) => language === lang)
              .shift() || {}
          ).items
          if (localizedResearchItems)
            localizedResearchItems.forEach(({ creators }) => {
              creators.forEach((creator) => {
                if (!researchPaperAuthors.includes(creator.key))
                  researchPaperAuthors.push(creator.key)
              })
            })

          const localisedTeamMembers = teamMembers.nodes
            .map((node) => {
              const teamMember = { ...node.childMarkdownRemark.frontmatter }
              if (!teamMember.is_team_member) return null

              // We want to show the team member contenet in english if the locale isn't available
              const memberContent =
                teamMember.localized.filter(
                  (locale) => locale.lang === lang
                )[0] ||
                teamMember.localized.filter((locale) => locale.lang === 'en')[0]

              if (!memberContent) return null
              if (
                teamMember.team &&
                !content.childMarkdownRemark.frontmatter.content.teams
                  .map((team) => team.key)
                  .includes(teamMember.team)
              )
                throw new Error(
                  `Invalid team ${teamMember.team} for member ${node.relativePath}`
                )

              teamMember.content = memberContent
              const slug = node.relativePath.replace(/^.*\/([^.]+)\.md$/, '$1')
              teamMember.slug = slug
              if (researchPaperAuthors.includes(slug))
                teamMember.content.profile_links.research = `/research/library/authors/${slug}/`
              if (blogAuthors.includes(slug))
                teamMember.content.profile_links.blog = `/blog/authors/${teamMember.slug}/page-1/`

              if (!teamMember.thumbnail)
                teamMember.thumbnail =
                  'https://ucarecdn.com/330f4b48-42e5-43ff-86bb-92683e84bf1c/'
              if (!teamMember.profile_image)
                teamMember.profile_image =
                  'https://ucarecdn.com/a3d997dc-1781-445f-ad59-ad0e58c24cf3/'
              return teamMember
            })
            .filter((member) => !!member)

          localisedTeamMembers.sort((a, b) => {
            if (a.order > b.order) return 1
            if (a.order < b.order) return -1
            if (a.title.toLowerCase() > b.title.toLowerCase()) return 1
            if (a.title.toLowerCase() < b.title.toLowerCase()) return -1
            return 0
          })

          console.log(localisedTeamMembers)

          return render({
            content: content.childMarkdownRemark.frontmatter.content,
            teamMembers: localisedTeamMembers,
            member:
              member &&
              localisedTeamMembers.filter(
                (teamMember) => teamMember.slug === member
              )[0]
          })
        }}
      />
    )}
  </LanguageConsumer>
)

Query.propTypes = {
  render: PropTypes.func.isRequired,
  member: PropTypes.string
}

export default Query
